import { render, staticRenderFns } from "./SelectCategoryItems.vue?vue&type=template&id=0d59af68"
import script from "./SelectCategoryItems.vue?vue&type=script&lang=js"
export * from "./SelectCategoryItems.vue?vue&type=script&lang=js"
import style0 from "./SelectCategoryItems.vue?vue&type=style&index=0&id=0d59af68&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports